<template lang="html">
  <div :class="{'subMenuItemMobileMenu':true, 'close-panel':!disabled}"
    @click="$emit('click')"
    :disabled="disabled" >
      <span v-if="labelId && labelId !== ''">{{ $t(labelId) }}</span>
      <span v-else>{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'MobileMenuSectionListItem',
  props: ['label', 'labelId', 'disabled']
}
</script>
